import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoaderComponent implements OnInit {
  private themeService = inject(ThemeService);

  spinnerColor?: string;
  spinnerClass?: string;

  ngOnInit(): void {
    this.spinnerColor = this.themeService.getSideBarColor();

    switch (this.spinnerColor) {
      case 'red':
        this.spinnerClass = 'badge-danger';
        break;
      case 'primary':
        this.spinnerClass = 'badge-primary';
        break;
      case 'blue':
        this.spinnerClass = 'badge-info';
        break;
      case 'green':
        this.spinnerClass = 'badge-success';
        break;
      default:
        this.spinnerClass = 'badge-info';
        break;
    }
  }
}
